import { environment } from "environments/environment";
import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter, map } from "rxjs/operators";
import { textChangeRangeIsUnchanged } from "typescript";
import { AuthService } from "./services/auth.service";
// import {
//   AngularFireDatabase,
//   AngularFireList,
//   AngularFireObject,
// } from "@angular/fire/database";
import { Observable } from "rxjs";
import { PageService } from "./services/page-service";
import { Route } from "@angular/compiler/src/core";
import { GlobalService } from "./services/global.service";
import moment from 'moment';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit{
    faviconMap: Record<string, string> = {
    shg: 'assets/images/faviconMulti.png',
    marketplace: 'assets/images/faviconSingle.png',
    fpo: 'assets/images/faviconFPO.png',
  };
  defaultTitle =
    JSON.parse(localStorage.getItem("client")) &&
    JSON.parse(localStorage.getItem("client"))["projectName"]
      ? JSON.parse(localStorage.getItem("client"))["projectName"]
      : environment.pageTitle;
  separator =
    JSON.parse(localStorage.getItem("client")) &&
    JSON.parse(localStorage.getItem("client"))["separator"]
      ? JSON.parse(localStorage.getItem("client"))["separator"]
      : environment.separator;
  appData: any;
  clientExists = false;
  reloadWeb = 0;
  subdomain: any;
  data: any;
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    // private db: AngularFireDatabase,
    public auth: AuthService,
    public service: PageService,
    public titleService: Title,
    public global: GlobalService,
  ) {}

  ngOnInit() {
    this.defaultTitle =
      JSON.parse(localStorage.getItem("client")) &&
      JSON.parse(localStorage.getItem("client"))["projectName"]
        ? JSON.parse(localStorage.getItem("client"))["projectName"]
        : environment.pageTitle;
    this.separator =
      JSON.parse(localStorage.getItem("client")) &&
      JSON.parse(localStorage.getItem("client"))["separator"]
        ? JSON.parse(localStorage.getItem("client"))["separator"]
        : environment.separator;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const rt = this.getChild(this.activatedRoute);
        rt.data.subscribe((data) => {
          this.titleService.setTitle(
            this.defaultTitle + this.separator + data.title,
          );
        });
      });

       this.setFavicon();
  }

 setFavicon() {
  const iconUrl = this.faviconMap[environment.clientName];

  console.log('Favicon loading:', iconUrl);

  // ✅ Remove ALL existing favicon links
  const head = document.getElementsByTagName('head')[0];
  const links = head.querySelectorAll("link[rel*='icon']");
  links.forEach(link => head.removeChild(link));

  // ✅ Create new favicon
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = iconUrl + '?v=' + new Date().getTime(); // 🚀 cache breaker

  head.appendChild(link);
}

  getClientInfo() {
    const appName = localStorage.getItem("clientName");
    if (
      appName != "salon" &&
      appName != "rred" &&
      appName != "saastest" &&
      appName != "ecommercetest"
    ) {
      console.log("app comp. check");
      this.service
        .getMethod("aggregator/getInfo")
        .then((data) => {
          this.data = data["data"];
          this.data["bill"] = data["bill"];
          if (this.data) {
            if (
              this.data["free_trial_enddate"] &&
              this.data["lead_type_id"] != "3"
            ) {
              this.data["diffDays"] = moment(
                this.data["free_trial_enddate"],
              ).diff(moment(new Date()), "days");
              if (this.data["diffDays"] <= 0) {
                localStorage.setItem("freetrial", "1");
                this.router.navigate(["/dashboard"]);
              }
            } else {
              console.log("client info");
              const nextBillDate = moment(
                new Date(this.data.bill["nxt_bill_date"]),
                "dd MMM yyyy",
              ).toISOString();
              const diifDays = moment(nextBillDate).diff(
                moment(new Date()),
                "days",
              );
              if (diifDays <= 0) {
                localStorage.setItem("purchase", "1");
                this.router.navigate(["/dashboard"]);
              } else {
                localStorage.removeItem("freetrial");
                localStorage.removeItem("purchase");
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
